export const round15 = (minutes: number): number =>
  Math.max(0, Math.round(minutes / 15) * 15)
